<template>
  <div class="">
    <el-form inline label-width="90px" class="form">

      <el-form-item :label="$ct('workName')">
        <el-input size="mini" v-model="name">

        </el-input>
      </el-form-item>

      <el-form-item :label="$ct('workStatus')">
        <el-select clearable v-model="status">
          <el-option :value="0" :label="$ct('all')"></el-option>
          <el-option :value="1" :label="$ct('unpublished')"></el-option>
          <el-option :value="100" :label="$ct('published')"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$ct('updatedTime')">
        <el-date-picker v-model="updated_at_from" type="datetime" :placeholder="$ct('startTime')">
        </el-date-picker>

        <el-date-picker v-model="updated_at_to" type="datetime" :placeholder="$ct('endTime')">
        </el-date-picker>

      </el-form-item>

      <div class="button-div">
        <el-button round size="mini" type="primary" @click="search">{{$ct('search')}}</el-button>
        <el-button round size="mini" @click="reset">{{$ct('reset')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
.search {
}
.button-div {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.form {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.item {
  width: 29%;
}
</style>

<script>
export default {
  data() {
    return {
      form: {}
    }
  },
  computed: {
    name: {
      get() {
        return this.$store.state.workManage.name
      },
      set(name) {
        this.$store.commit('setState', {
          module: 'workManage',
          key: 'name',
          value: name
        })
      }
    },
    status: {
      get() {
        return this.$store.state.workManage.status
      },
      set(status) {
        this.$store.commit('setState', {
          module: 'workManage',
          key: 'status',
          value: status
        })
      }
    },
    updated_at_from: {
      get() {
        return this.$store.state.workManage.updated_at_from
      },
      set(updated_at_from) {
        this.$store.commit('setState', {
          module: 'workManage',
          key: 'updated_at_from',
          value: updated_at_from
        })
      }
    },
    updated_at_to: {
      get() {
        return this.$store.state.workManage.updated_at_to
      },
      set(updated_at_to) {
        this.$store.commit('setState', {
          module: 'workManage',
          key: 'updated_at_to',
          value: updated_at_to
        })
      }
    },

    username: {
      get() {
        return this.$store.state.workManage.username
      },
      set(username) {
        this.$store.commit('setState', {
          module: 'workManage',
          key: 'username',
          value: username
        })
      }
    }

  },
  methods: {
    reset() {
      this.$store.commit('workManageInit')
      this.search()
    },
    search() {
      if (this.updated_at_to && !this.updated_at_from) {
        this.$message({
          type: 'error',
          message: this.$ct('messages.starTime')
        })
        return
      }
      if (!this.updated_at_to && this.updated_at_from) {
        this.$message({
          type: 'error',
          message: this.$ct('messages.endTime')
        })
        return
      }
      this.$store.commit('setState', {
        module: 'workManage',
        key: 'user_id',
        value: ''
      })
      this.$emit('getData')
    },
    statusChange(value) {
      this.min_score = undefined
      this.max_score = undefined
    }
  },
  mounted() {}
}
</script>
